"use strict";

const EventImpl = require("./Event-impl").implementation;

const HashChangeEventInit = require("../generated/HashChangeEventInit");

class HashChangeEventImpl extends EventImpl {

}
HashChangeEventImpl.defaultInit = HashChangeEventInit.convert(undefined, undefined);

module.exports = {
  implementation: HashChangeEventImpl
};
